import { render, staticRenderFns } from "./onboarding-pending-bar.vue?vue&type=template&id=40c58db4&scoped=true&"
import script from "./onboarding-pending-bar.vue?vue&type=script&lang=js&"
export * from "./onboarding-pending-bar.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-pending-bar.vue?vue&type=style&index=0&id=40c58db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c58db4",
  null
  
)

export default component.exports